import PaymentWatchers from './Payments';

export default PaymentWatchers;
